import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'CustomPostList',
    column_type: 'id',
  },
  created_at: {
    model_name: 'CustomPostList',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'CustomPostList',
    column_type: 'datetime',
  },
  remark: {
    model_name: 'CustomPostList',
    column_type: 'string',
  },
  title: {
    model_name: 'CustomPostList',
    column_type: 'string',
  },
  custom_post_lists_posts: {
    model_name: 'CustomPostList',
    column_type: 'has_many',
    extra: {
      association_name: 'custom_post_lists_posts',
      model_name: 'CustomPostListsPost',
      foreign_key: 'custom_post_list_id',
    },
  },
  custom_post_lists_post_ids: {
    model_name: 'CustomPostList',
    column_type: 'has_many',
    extra: {
      association_name: 'custom_post_lists_posts',
      model_name: 'CustomPostListsPost',
      foreign_key: 'custom_post_list_id',
    },
  },
  posts: {
    model_name: 'CustomPostList',
    column_type: 'has_many',
    extra: {
      association_name: 'posts',
      model_name: 'Post',
      foreign_key: 'post_id',
    },
  },
  post_ids: {
    model_name: 'CustomPostList',
    column_type: 'has_many',
    extra: {
      association_name: 'posts',
      model_name: 'Post',
      foreign_key: 'post_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
